module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAoCAYAAACfKfiZAAABWElEQVRYR+2YP07DMBTGPytzDlAz0Cl1NoayNx0qdWOAdikD6gXoCbgCB2hhIF2q7pUY6AHowkQ60QX3FjF6EkFCqh0ZR6GDvcbvfZ9/788QFkXRRRAEdwDOUONRSu3yPJ8wIcQHY6xZo/aPFJlgcRyr/xAvNL0BT8AT8ASOl0AYhphOHyBE7LQos+wdw+GVNoeWQLt9jtns0Um8CB6Pb7DZvB7MpTVABMhAqyWcTGy3GQaDS3sCTqoWwcfbhBaPcLpqJMA5R6PBnQT2ewkppX0PkPhq9ewkXgT3+z2tCS0B6v7FYlmJAZoCmoZDx1iC0egaSdJ1MrFevyBNn+xL4KRqEezHsLQHOp3ECJRqPJ+nFtB/X61kCkxdXuZMa8BmD5jm/M8GKJBMcH5izCHlp3HTORkoC67iux9DT8AT8ASIwA7AaRVLxTaHUuqNff+mu6/bBIkDuP0CwZ2QauyLK9YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar/orderIconActive.png
// module id = BFlL
// module chunks = 1